module.exports = "<a href=javascript: class=mui-btn :class=\"{'mui-btn-disabled': disabled,\n  'mui-btn-mini': mini,\n  'mui-btn-transparent': transparent,\n  'mui-btn-default': type === 'default',\n  'mui-btn-brand': type === 'brand',\n  'mui-btn-primary': type === 'primary',\n  'mui-btn-warn': type === 'warn',\n  'mui-btn-dangerous': type === 'dangerous'\n}\"><slot>{{ text }}</slot></a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/m-button/index.vue
 ** module id = 165
 ** module chunks = 0
 **/